import intl from "react-intl-universal";
import { TbAdjustmentsHorizontal, TbCalendar, TbSwitchHorizontal } from "react-icons/tb";
import { ModernFilterBar } from "../../../../../Components/Molecules/Filters/ModernFilterBar";
import {
  CheckboxListFilterPanel,
  DateFilterPanel,
  MoreFiltersCheckboxSection,
} from "../../../../../Components/Molecules/Filters/ModernFilterPanels";
import {
  EMPTY_BAAS_ENTIDADES_FILTERS,
  buildBaasEntidadesFilterTags,
  getBaasEntityKybStatusOptions,
  getBaasEntityStatusOptions,
  getBaasEntityTypeOptions,
  hasActiveBaasEntidadesFilters,
  isBaasEntidadesChipFilterActive,
  removeBaasEntidadesFilterTag,
} from "../baasEntidadesFilters";

const BaasEntidadesMoreFiltersForm = ({ draft, onChange }) => (
  <div className="extract-more-filters-form">
    <MoreFiltersCheckboxSection
      label={intl.get("baas.entidades.filterKyb")}
      options={getBaasEntityKybStatusOptions()}
      selectedValues={draft.kybStatuses}
      onChange={(kybStatuses) => onChange({ ...draft, kybStatuses })}
      idPrefix="baas-entidades-more-kyb"
    />
  </div>
);

export const BaasEntidadesFilterBar = ({ filters, onFiltersChange, filteredItems }) => {
  const filterButtons = [
    {
      id: "date",
      icon: TbCalendar,
      label: intl.get("baas.entidades.filterDate"),
      active: isBaasEntidadesChipFilterActive(filters, "date"),
    },
    {
      id: "status",
      icon: TbAdjustmentsHorizontal,
      label: intl.get("baas.entidades.filterStatus"),
      active: isBaasEntidadesChipFilterActive(filters, "status"),
    },
    {
      id: "type",
      icon: TbSwitchHorizontal,
      label: intl.get("baas.entidades.filterType"),
      active: isBaasEntidadesChipFilterActive(filters, "type"),
    },
  ];

  const renderPanelContent = (panelId, draft, onChange) => {
    switch (panelId) {
      case "date":
        return <DateFilterPanel draft={draft} onChange={onChange} />;
      case "status":
        return (
          <CheckboxListFilterPanel
            options={getBaasEntityStatusOptions()}
            selectedValues={draft.statuses}
            onChange={(statuses) => onChange({ ...draft, statuses })}
            idPrefix="baas-entidades-status"
          />
        );
      case "type":
        return (
          <CheckboxListFilterPanel
            options={getBaasEntityTypeOptions()}
            selectedValues={draft.types}
            onChange={(types) => onChange({ ...draft, types })}
            idPrefix="baas-entidades-type"
          />
        );
      default:
        return null;
    }
  };

  return (
    <ModernFilterBar
      filters={filters}
      onFiltersChange={onFiltersChange}
      emptyFilters={EMPTY_BAAS_ENTIDADES_FILTERS}
      searchPlaceholder={intl.get("baas.entidades.searchPlaceholder")}
      filterButtons={filterButtons}
      moreFiltersActive={isBaasEntidadesChipFilterActive(filters, "more")}
      buildFilterTags={buildBaasEntidadesFilterTags}
      hasActiveFilters={hasActiveBaasEntidadesFilters}
      removeFilterTag={removeBaasEntidadesFilterTag}
      renderPanelContent={renderPanelContent}
      renderMoreFilters={(draft, onChange) => (
        <BaasEntidadesMoreFiltersForm draft={draft} onChange={onChange} />
      )}
      filteredItems={filteredItems}
      showExport={false}
      panelTitles={{
        date: intl.get("baas.entidades.filterDate"),
        status: intl.get("baas.entidades.filterStatus"),
        type: intl.get("baas.entidades.filterType"),
      }}
    />
  );
};
